import PageShell from "@/components/layout/PageShell";
import SearchWidget from "@/components/shared/SearchWidget";
import CategoryCard from "@/components/shared/CategoryCard";
import ProviderStrip from "@/components/shared/ProviderStrip";
import FAQAccordion from "@/components/shared/FAQAccordion";
import { CATEGORIES, FAQS_GENERAL } from "@/lib/data";

export default function Categories() {
  return (
    <PageShell>
      <section className="bg-[#0B2545] text-white pt-16 md:pt-24 pb-14 md:pb-20" data-testid="categories-hero">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="overline-light mb-6">Rental categories · 8 classes</div>
          <h1 className="font-serif text-[9vw] md:text-[6vw] lg:text-[5vw] leading-[1.02] tracking-[-0.02em] text-white max-w-5xl">
            Every class of rental car — compared across nine US providers.
          </h1>
          <p className="mt-8 text-white/85 text-lg md:text-xl leading-relaxed max-w-3xl">
            From economy hatchbacks to full-size SUVs, minivans, and pickups. Prices shown are
            starting-from estimates based on recent averages.
          </p>
        </div>
        <div className="relative -mb-14 md:-mb-16 z-10 mt-10 md:mt-14 mx-auto max-w-[1600px] px-5 md:px-10">
          <SearchWidget variant="compact" />
        </div>
      </section>

      <div className="h-14 md:h-16 bg-white" />
      <ProviderStrip />

      <section className="py-20 md:py-28 bg-white">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {CATEGORIES.map((c, i) => (
              <CategoryCard key={c.slug} category={c} index={i} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-[#F5F7FA] border-t border-line">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="overline mb-4">Category FAQ</div>
            <h2 className="font-serif text-4xl md:text-5xl text-[#0B2545] leading-tight">
              Class questions, answered.
            </h2>
          </div>
          <div className="md:col-span-8">
            <FAQAccordion items={FAQS_GENERAL.slice(0, 5)} testIdPrefix="categories-faq" />
          </div>
        </div>
      </section>
    </PageShell>
  );
}
